import { cache } from './cache';

/**
 * Cache invalidation utilities for consistent cache management
 */

export const invalidateClubsCache = (user?: { role: string; id: string } | null) => {
  // Clear user-specific cache
  if (user?.role && user?.id) {
    cache.clear(`clubs_${user.role}_${user.id}`);
  }
  
  // Clear public cache
  cache.clear('clubs_public');
  
  console.log('Cache invalidated: clubs');
};

export const invalidateEventsCache = () => {
  // Clear authenticated events cache
  cache.clear('events_authenticated');
  
  // Clear public events cache
  cache.clear('events_public');
  
  console.log('Cache invalidated: events');
};

export const invalidateAnnouncementsCache = () => {
  cache.clear('announcements');
  console.log('Cache invalidated: announcements');
};

export const invalidateAllCache = () => {
  cache.clear();
  console.log('Cache invalidated: all entries');
};

/**
 * Use this function after any CREATE, UPDATE, or DELETE operation
 * to ensure fresh data is fetched on next request
 */
export const invalidateCacheAfterMutation = (entityType: 'clubs' | 'events' | 'announcements' | 'all', user?: { role: string; id: string } | null) => {
  switch (entityType) {
    case 'clubs':
      invalidateClubsCache(user);
      break;
    case 'events':
      invalidateEventsCache();
      break;
    case 'announcements':
      invalidateAnnouncementsCache();
      break;
    case 'all':
      invalidateAllCache();
      break;
  }
};
